import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { buildNavigation } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('../pages/RootPage'))
const BundlesHomepage = React.lazy(() => import('../pages/BundlesHomepage'))
const ContactSalesModalPage = React.lazy(() => import('../pages/ContactSalesModalPage'))
const CustomBundlesHomepage = React.lazy(() => import('../pages/CustomBundlesHomepage'))
const PaymentErrorPage = React.lazy(() => import('../pages/PaymentErrorPage'))
const PaymentModalPage = React.lazy(() => import('../pages/PaymentModalPage'))
const PaymentSuccessPage = React.lazy(() => import('../pages/PaymentSuccessPage'))
const UpgradeModalPage = React.lazy(() => import('../pages/UpgradeModalPage'))

export const billingRoutes = buildNavigation((navigation) => {
  return [
    {
      path: navigation.upgradePlan.path,
      element: <RootPage />,
      handle: {
        module: 'billing',
        meta: () => ({
          title: i18n.t('pricing_plans.page_title'),
          description: i18n.t('pricing_plans.page_description'),
          illustration: 'rocket',
        }),
      },
      children: [
        {
          index: true,
          element: <BundlesHomepage />,
        },
        {
          path: navigation.upgradePlan.customBundles.path,
          handle: {
            meta: () => ({
              title: i18n.t('billing.upgrade_plan.custom_bundles.section_title'),
              description: i18n.t('billing.upgrade_plan.custom_bundles.section_description'),
              illustration: 'wireframe',
            }),
          },
          element: <CustomBundlesHomepage />,
        },
        {
          path: navigation.upgradePlan.success.path,
          element: <PaymentSuccessPage />,
        },
        {
          path: navigation.upgradePlan.error.path,
          element: <PaymentErrorPage />,
        },
      ],
    },
    {
      path: navigation.upgradePlan.payment.path,
      element: <PaymentModalPage />,
    },
    {
      path: navigation.upgradePlan.upgrade.path,
      element: <UpgradeModalPage />,
    },
    {
      path: navigation.upgradePlan.contactSales.path,
      element: <ContactSalesModalPage />,
    },
  ]
})
